import request from '@/utils/request';
// 查询短信发送记录分页列表
export function getSendsPageList(options) {
  return request({
    url: `/sms/sends/page`,
    method: 'get',
    params: options
  });
}

// 查询待审核短信模板分页列表
export function getAuditPageList(options) {
  return request({
    url: `/sms/templates/unaudited/page`,
    method: 'get',
    params: options
  });
}

// 查询已审核短信模板分页列表
export function getAuditedPageList(options) {
  return request({
    url: `/sms/templates/audited/page`,
    method: 'get',
    params: options
  });
}

// 查询短信模板分页列表
export function getTemplatesPageList(options) {
  return request({
    url: `/sms/templates/page`,
    method: 'get',
    params: options
  });
}

// 获取短信模板
export function getSmsTemplatesInfo(templateId) {
  return request({
    url: `/sms/templates/${templateId}`,
    method: 'get'
  });
}

// 修改第三方审核不通过原因
export function updateThirdAuditReject(op) {
  return request({
    url: `/sms/templates/audit/third/reject/cause`,
    method: 'put',
    data: op
  });
}

// 审核不通过
export function reviewFailed(op) {
  return request({
    url: `/sms/templates/audit/reject`,
    method: 'post',
    data: op
  });
}

// 重新申请审核
export function reApplyReview(op) {
  return request({
    url: `/sms/templates/audit/reapply`,
    method: 'post',
    data: op
  });
}

// 审核通过
export function approved(op) {
  return request({
    url: `/sms/templates/audit/approve`,
    method: 'post',
    data: op
  });
}

// 应用学校
export function getApplySchool(op) {
  return request({
    url: `/sms/templates/apply/school`,
    method: 'put',
    data: op
  });
}
